export function useProduct(product) {

  const variants = Array.isArray(product?.variantes)
    ? product.variantes
    : [];

  /* =========================
     🔹 VARIANT DETECTION
  ========================= */

  function hasVariants() {

    if (!variants.length) return false;

    if (variants.length > 1) return true;

    const v = variants[0];

    if (!v) return false;

    return v.title && v.title !== "Default Title";

  }

  function getUnitsFromVariants() {
    return variants
      .map(v => v.unit)
      .filter(Boolean);
  }

  function hasBothUnits() {
    const units = getUnitsFromVariants();
    return units.includes("lb") && units.includes("pz");
  }

  function detectInitialMode() {

    const units = getUnitsFromVariants();

    if (units.includes("lb") && !units.includes("pz")) return "lb";

    if (units.includes("pz")) return "pz";

    if (units.includes("lb")) return "lb";

    return "pz";

  }

  function getVariantByUnit(unit) {

    if (!variants.length) return null;

    const byUnit = variants.find(v => v.unit === unit);

    if (byUnit) return byUnit;

    return variants[0];

  }

  /* =========================
     📦 QTY LOGIC
  ========================= */

  function getInitialQty() {
    return 1;
  }

  function increaseQty(qty) {
    return qty + 1;
  }

  function decreaseQty(qty) {
    return qty > 1 ? qty - 1 : qty;
  }

  /* =========================
     🚀 EXPORT
  ========================= */

  return {
    variants,
    hasVariants,
    hasBothUnits,
    getVariantByUnit,
    detectInitialMode,
    getInitialQty,
    increaseQty,
    decreaseQty
  };

}